"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canHaveDocumentDate = exports.canHaveDocumentNumber = exports.canHaveExpirationDate = exports.getTemplateDescription = void 0;
var DOCUMENT_TEMPLATE_INFO = {
    ASS_MOTO: {
        description: 'Police d’assurance pour le transport de personnes à moto',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    ASS_VEHICLE: {
        description: 'Police d’assurance pour le transport de personnes en voiture',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    DRIVER_LICENSE_RECTO: {
        description: 'Permis de conduire (recto)',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    DRIVER_LICENSE_VERSO: {
        description: 'Permis de conduire (verso)',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    KBIS: { description: 'Kbis de moins de 3 mois', canHaveExpirationDate: false, canHaveDocumentNumber: false, canHaveDocumentDate: false },
    LICENSE_ATOUT: { description: 'Inscription registre VTC', canHaveExpirationDate: true, canHaveDocumentNumber: true, canHaveDocumentDate: false },
    LICENSE_CAPACITY: {
        description: 'Licence capacité voyageurs',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: true,
        canHaveDocumentDate: false,
    },
    PRO_CARD_MOTO_RECTO: {
        description: 'Carte pro moto-taxi (recto)',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: true,
        canHaveDocumentDate: false,
    },
    PRO_CARD_MOTO_VERSO: {
        description: 'Carte pro moto-taxi (verso)',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    PROD_CARD_VTC_RECTO: {
        description: 'Carte pro VTC (recto)',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: true,
        canHaveDocumentDate: false,
    },
    PROD_CARD_VTC_VERSO: {
        description: 'Carte pro VTC (verso)',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    RESP: {
        description: 'Responsabilité Civile Professionnelle',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    RIB: { description: "Relevé d'identité bancaire", canHaveExpirationDate: false, canHaveDocumentNumber: false, canHaveDocumentDate: false },
    TAXI_METROLOGY_FILE: { description: 'Carnet métrologique', canHaveExpirationDate: false, canHaveDocumentNumber: false, canHaveDocumentDate: false },
    TAXI_PARK_AUTHORIZATION: {
        description: 'Autorisation de stationnement / licence',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    TAXI_PRO_CARD_RECTO: {
        description: 'Carte professionnelle de taxi (recto)',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: true,
        canHaveDocumentDate: false,
    },
    TAXI_PRO_CARD_VERSO: {
        description: 'Carte professionnelle de taxi (verso)',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    TAXI_TRAINING_MANIFEST: {
        description: 'Attestation de suivi de stage de formation',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    TAXI_YELLOW_CARD: {
        description: 'Carte jaune (fiche médicale)',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    VEHICLE_CERTIFICATE: {
        description: 'Carte grise du véhicule',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    DISABILITY_TRAINING: {
        description: 'Attestation de formation au Transport de Personnes à Mobilité Réduite',
        canHaveExpirationDate: false,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    RIR: {
        description: 'Relevé d’information restreint (RIR)',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
    TECHNICAL_CONTROL: {
        description: 'Contrôle technique',
        canHaveExpirationDate: true,
        canHaveDocumentNumber: false,
        canHaveDocumentDate: false,
    },
};
var getTemplateDescription = function (template) {
    if (DOCUMENT_TEMPLATE_INFO[template]) {
        return DOCUMENT_TEMPLATE_INFO[template].description;
    }
    else {
        return 'NO DESCRIPTION FOR DOCUMENT : ' + template;
    }
};
exports.getTemplateDescription = getTemplateDescription;
var canHaveExpirationDate = function (template) {
    if (DOCUMENT_TEMPLATE_INFO[template]) {
        return DOCUMENT_TEMPLATE_INFO[template].canHaveExpirationDate;
    }
    else {
        return false;
    }
};
exports.canHaveExpirationDate = canHaveExpirationDate;
var canHaveDocumentNumber = function (template) {
    if (DOCUMENT_TEMPLATE_INFO[template]) {
        return DOCUMENT_TEMPLATE_INFO[template].canHaveDocumentNumber;
    }
    else {
        return false;
    }
};
exports.canHaveDocumentNumber = canHaveDocumentNumber;
var canHaveDocumentDate = function (template) {
    if (DOCUMENT_TEMPLATE_INFO[template]) {
        return DOCUMENT_TEMPLATE_INFO[template].canHaveDocumentDate;
    }
    else {
        return false;
    }
};
exports.canHaveDocumentDate = canHaveDocumentDate;
